import { SET_APP_NOTIFICATION_DATA, SET_APP_STATUS } from '../../actionTypes/notifications'

export const setAppNotificationData = value => ({ type: SET_APP_NOTIFICATION_DATA, value })
export const setAppStatus = value => ({ type: SET_APP_STATUS, value })
